import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Theme,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { detectAgent } from 'core/utils';
import supportTrack from 'src/support/handlers/track';

const useStyles = makeStyles((theme: Theme) => ({
  expPanel: {
    border: '1px solid',
    borderWidth: '1px 0px',
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.grey[800],
    boxShadow: 'none',
    marginBottom: '0px !important',
    // paddingBottom: '16px',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expDetail: {
    paddingLeft: '8px',
    paddingBottom: '32px',
    fontSize: '16px',
  },
  expanded: {
    color: theme.palette.primary.main,
    // backgroundColor: '#ffffff',
  },
  heading: {
    fontWeight: 600,
  },
  root: {
    // width: "100%",
    fontWeight: 600,
    minHeight: '70px',
    // color: '#4F4F4F',
    padding: '8px',
    color: '#484B4E',
    '&:hover': {
      color: theme.palette.primary.dark,
      backgroundColor: theme.palette.grey[50],
    },

    [theme.breakpoints.down(767)]: {
      fontSize: '15px',
    },
  },
  faqholder: {
    marginBottom: '40px',
  },
}));

interface IProps {
  classes: Record<string, string>;
  /* classes: {
    font20: string;
    font26: string;
  }; */
}

function FAQ(props: IProps) {
  const [isMobile, setIsMobile] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setIsMobile(!!detectAgent().isMobile);
  }, []);

  const renderFAQ = (question: string, answer: string | JSX.Element, style = {}) => (
    <Accordion
      classes={{ root: classes.expPanel }}
      style={{ width: '100%', ...style }}
      onChange={(event, expanded) => {
        if (expanded) supportTrack.faqOpened('Grammar-check FAQ', question);
      }}
    >
      <AccordionSummary
        classes={{ root: classes.root, expanded: classes.expanded }}
        className="qbp-semibold"
        aria-controls="panel1bh-content"
      >
        <Typography className={classes.heading} display="block">
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.expDetail }} style={{ flexDirection: 'column' }}>
        {answer}
      </AccordionDetails>
    </Accordion>
  );

  return (
    <Box mt={isMobile ? 0 : 5} className={props.classes.faqBox}>
      <Grid container>
        <Grid item xs={12} className={`${classes.faqholder}`}>
          {renderFAQ(
            'Is the affiliate program open to everyone?',
            'Yep! Anyone who wants to join can apply to become our affiliate partner.'
          )}
          {renderFAQ(
            'What happens next?',
            'Just provide a few details to sign up and you’ll receive a confirmation email. Once your partnership is confirmed, you’ll receive a personal referral link you can start sharing right away and get access to your referral dashboard.'
          )}
          {renderFAQ(
            'How do I get paid?',
            'Payments are verified and paid out the month after your commission is earned. For example, any commissions earned in February will be available March 16th.'
          )}
          {renderFAQ(
            'Do you provide any help with referrals?',
            'Absolutely. Your affiliate manager will answer questions, provide training, and offer ongoing marketing support. We also provide resources and co-branded promotional materials that you can access via your dashboard or Referral Coach.'
          )}
          {renderFAQ(
            'How are my referrals tracked?',
            'We use cookies to track your referrals. The cookies last for 30 days after someone clicks on your link. If they click again, the 30-day period is reset and it starts again.'
          )}
          {renderFAQ(
            'What is PartnerStack?',
            'PartnerStack is the platform we use to run the QuillBot Affiliate Program. You can use PartnerStack to see whom you referred and how they’re doing in QuillBot.'
          )}
          {renderFAQ(
            'How long do commissions last for?',
            'The commission period will be stated in your specific partner’s group.'
          )}
          {renderFAQ(
            'Do you have more questions?',
            <>
              If you have any questions or need help please email:{' '}
              <a href="mailto:affiliate@quillbot.com" className="btn-link">
                affiliate@quillbot.com
              </a>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default FAQ;
